// extracted by mini-css-extract-plugin
module.exports = {"resourcesParent":"Lab_resourcesParent__21m8s","resourceCard":"Lab_resourceCard__3wAhK","cardTitle":"Lab_cardTitle__3ghrq"};